import { forwardRef, type Ref } from 'react';
import CoreInput, { type InputProps as CoreInputProps } from '@ovpn/ui/input';
import Label, { type LabelOwnProps } from '@ovpn/ui/label';

import { boxed } from '@sso/shared/hocs';

type InputProps = CoreInputProps & Omit<LabelOwnProps, 'children' | 'as'>;

function Input(
    {
        description,
        appearance,
        className,
        layout,
        title,
        size,
        dir,

        ...inputProps
    }: InputProps,
    ref: Ref<HTMLInputElement>,
) {
    return (
        <Label
            appearance={inputProps.invalid ? 'warning' : appearance}
            required={inputProps.required}
            data-testid={inputProps.id}
            description={description}
            className={className}
            layout={layout}
            title={title}
            size={size}
            dir={dir}
        >
            <CoreInput ref={ref} {...inputProps} />
        </Label>
    );
}

export default boxed(forwardRef(Input));
